module.exports = __webpack_public_path__ + "static/media/auaActive.a5ea5262.svg";